import React, { Suspense } from 'react';
import AuthenticationSettingsModel from './AuthenticationSettingsModel';
import { useCardStyle } from './UdfEditor';
import { Observe } from 'rewire-core';
import { FormView } from 'rewire-ui';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Typography from '@material-ui/core/Typography';
import { Theme } from '@material-ui/core/styles';
import { Apple, MicrosoftAzure, FormTextboxPassword, AccountHardHat } from 'mdi-material-ui';
import MainContentToolbar from '../main-navigation/MainContentToolbar';
import Breadcrumbs from '../main-navigation/Breadcrumbs';
import { ToolbarSaveButton } from './RuleSettingsEditor';
import { makeStyles } from '../utility/styles';

const AuthenticationDocumentation = React.lazy(() => import('../documentation/authentication/authentication.mdx'));

const style = (theme: Theme) => ({
  label: { display: 'flex', marginTop: 24, columnGap: 40, borderBottom: '1px solid lightgrey' },
  control: { marginLeft: 0, flex: '1', display: 'flex', alignItems: 'center' },
  heading: { flexBasis: 'auto', fontWeight: 'normal' },
  label2: { display: 'flex', alignItems: 'center' },
  main: {
    display: 'flex',
    flex: '0 0 auto',
    alignItems: 'center',
    overflow: 'auto',
    minHeight: 40,
    justifyContent: 'flex-start',
  },
});

const useAuthenticationStyles = makeStyles(style);

export default React.memo(({ settings, classes }: { settings: AuthenticationSettingsModel; classes?: any }) => {
  const cardClasses = useCardStyle({ classes });
  const cls = useAuthenticationStyles();
  return (
    <div className={cardClasses.container}>
      <div className={cardClasses.left}>
        <MainContentToolbar>
          <div className={cls.main}>
            <Breadcrumbs />
          </div>
        </MainContentToolbar>

        <Observe
          render={() => (
            <>
              <div style={{ display: 'flex' }}>
                <Typography variant="h6" style={{ flex: '1' }}>
                  Authentication Options
                </Typography>
                <ToolbarSaveButton settings={settings} style={{ width: 120, minHeight: 32, marginRight: 4 }} />
              </div>
              <div className={cls.label}>
                <FormControlLabel
                  className={cls.control}
                  disabled={true}
                  control={
                    <Switch
                      checked={settings.usernamePassword}
                      onChange={() => (settings.usernamePassword = !settings.usernamePassword)}
                      color="primary"
                    />
                  }
                  label={
                    <div className={cls.label2}>
                      <FormTextboxPassword />
                      <Typography variant="h6" className={cls.heading}>
                        Username Password
                      </Typography>
                    </div>
                  }
                />
              </div>
              <div className={cls.label} style={{ flexDirection: 'column' }}>
                <FormControlLabel
                  className={cls.control}
                  control={<Switch checked={settings.saml} onChange={() => (settings.saml = !settings.saml)} color="primary" />}
                  label={
                    <div className={cls.label2}>
                      <MicrosoftAzure />
                      <Typography variant="h6" className={cls.heading}>
                        Single Sign-on (Active Directory)
                      </Typography>
                    </div>
                  }
                />
                {settings.saml ? (
                  <div style={{ display: 'flex' }}>
                    <FormView style={{ flexBasis: 600 }} form={settings.form} onSubmit={() => {}}>
                      <div className="content">
                        <settings.form.field.entityID.Editor className="span1" />
                      </div>
                      <div className="content">
                        <settings.form.field.replyURL.Editor className="span1" />
                      </div>
                      <div className="content">
                        <settings.form.field.metadataURL.Editor className="span1" disable={settings.isLoading} />
                      </div>
                    </FormView>
                    <Suspense fallback={null}>
                      <div style={{ flex: 1 }}>
                        <AuthenticationDocumentation name={`bars ${settings.apple}`} year={2022} />
                      </div>
                    </Suspense>
                  </div>
                ) : null}
              </div>
              <div className={cls.label}>
                <FormControlLabel
                  className={cls.control}
                  disabled={true}
                  control={<Switch checked={settings.apple} onChange={() => (settings.apple = !settings.apple)} color="primary" />}
                  label={
                    <div className={cls.label2}>
                      <Apple />
                      <Typography variant="h6" className={cls.heading}>
                        Apple (coming soon)
                      </Typography>
                    </div>
                  }
                />
              </div>
              <div className={cls.label}>
                <FormControlLabel
                  className={cls.control}
                  disabled={true}
                  control={<Switch checked={settings.mfa} onChange={() => (settings.mfa = !settings.mfa)} color="primary" />}
                  label={
                    <div className={cls.label2}>
                      <AccountHardHat />
                      <Typography variant="h6" className={cls.heading}>
                        Enable Multi-Factor Authentication (coming soon)
                      </Typography>
                    </div>
                  }
                />
              </div>
            </>
          )}
        />
      </div>
    </div>
  );
});
